import { useCallback, useMemo, useRef, useState, useEffect } from "react";
import colors from "../../../Utils/colors";
import ReactFlow, {
  Background,
  BackgroundVariant,
  Controls,
  MiniMap,
  Edge,
  Node,
  OnEdgesChange,
  OnNodesChange,
} from "reactflow";

import "reactflow/dist/style.css";

import { eventsend } from "../../../Config/analyticsFunctions";
import DefaultResponseNode from "../../WorkFlow/Nodes/DefaultResponseNode";
import IncomingWANode from "../../WorkFlow/Nodes/IncomingWANode";
import ResponseMessageNode from "../../WorkFlow/Nodes/ResponseMessageNode";
import ConditionNode from "../../WorkFlow/Nodes/ConditionNode";
import TimeDelayNode from "../../WorkFlow/Nodes/TimeDelayNode";
import AssignToChatBot from "../../WorkFlow/Nodes/AssignToChatBot";
import SendEmailNode from "../../WorkFlow/Nodes/SendEmailNode";
import SendSMSNode from "../../WorkFlow/Nodes/SendSMSNode";
import InvokeNewFlow from "../../WorkFlow/Nodes/InvokeNewFlow";
import SendWATemplate from "../../WorkFlow/Nodes/SendWATemplate";
import EndFlowNode from "../../WorkFlow/Nodes/EndFlowNode";
import ShopifyOrderNode from "../../WorkFlow/Nodes/ShopifyOrderNode";
import FacebookLeadNode from "../../WorkFlow/Nodes/FacebookLeadNode";
import AssignAgentNode from "../../WorkFlow/Nodes/AssignAgentNode";
import AssignGPTNode from "../../WorkFlow/Nodes/AssignGPTNode";
import LlamaNode from "../../WorkFlow/Nodes/LlamaNode";
import CampaignSentNode from "../../WorkFlow/Nodes/CampaignSentNode";
import KylasUpdateNode from "../../WorkFlow/Nodes/KylasUpdateNode";
import KylasCreateNode from "../../WorkFlow/Nodes/KylasCreateNode";
import IncomingInstagramNode from "../../WorkFlow/Nodes/IncomingInstagramNode";
import InstagramResponseNode from "../../WorkFlow/Nodes/InstagramResponseNode";
import UpdateAttributeNode from "../../WorkFlow/Nodes/UpdateAttributeNode";
import AttributeConditionNode from "../../WorkFlow/Nodes/AttributeConditionNode";
import UpdateChatStatusNode from "../../WorkFlow/Nodes/UpdateChatStatusNode";
import PabblyEventNode from "../../WorkFlow/Nodes/PabblyEventNode";
import WebhookTriggerNode from "../../WorkFlow/Nodes/WebhookTriggerNode";
import SendWACatalog from "../../WorkFlow/Nodes/SendWACatalog";
import WAPaymentNode from "../../WorkFlow/Nodes/WAPaymentNode";
import IncomingWebhookNode from "../../WorkFlow/Nodes/IncomingWebhookNode";
import WooCommerceNode from "../../WorkFlow/Nodes/WooCommerceNode";
import NewContactNode from "../../WorkFlow/Nodes/NewContactNode";
import UpdateShopifyAttributesNode from "../../WorkFlow/Nodes/UpdateShopifyAttributesNode";
import PixelEventNode from "../../WorkFlow/Nodes/PixelEventNode";
import UpdateBroadCastNode from "../../WorkFlow/Nodes/UpdateBroadCastNode";
import InstagramEventNode from "../../WorkFlow/Nodes/InstagramEventNode";
import FormNode from "../../WorkFlow/Nodes/FormNode";
import { KeyPressOverviewModal } from "../../WorkFlow/KeyPressPreviewModal";
import AddToLabel from "../../WorkFlow/Nodes/AddToLabelNode";
import FeedbackCollectionNode from "../../WorkFlow/Nodes/FeedbackCollectionNode";
import AssignAIAssistantNode from "../../WorkFlow/Nodes/AssignAIAssistantNode";
import CodeNode from "../../WorkFlow/Nodes/CodeNode";


type WorkflowPreviewProps = {
  nodes: Node[];
  edges: Edge[];
  onNodesChange: OnNodesChange;
  onEdgesChange: OnEdgesChange;
};

const WorkflowPreview: React.FC<WorkflowPreviewProps> = ({
  nodes,
  edges,
  onEdgesChange,
  onNodesChange,
}) => {


  const reactFlowWrapper = useRef<HTMLDivElement>(null);

  const [editNodeData, setEditNodeData] = useState<Node | null>(null);
  const [selectedNodeId, setSelectedNodeId] = useState<string | null>(null);
  const [selectedEdgeId, setSelectedEdgeId] = useState<string | null>(null);
  const [showKeyPressModal, setShowKeyPressModal] = useState(false);
  let prevNode: Node | null = null;

  console.log(setEditNodeData, setSelectedNodeId, setSelectedEdgeId, prevNode)
  useEffect(() => {
    const hasSeenModal = localStorage.getItem('hasSeenKeyPressModal');
    if (hasSeenModal !== 'true') {
      setShowKeyPressModal(true);
    }
    eventsend("Workflow_nodes_clicks");
  }, []);

  const handleModalHide = () => {
    setShowKeyPressModal(false);
    localStorage.setItem('hasSeenKeyPressModal', 'true');
  };

  const customNodeStyles = {
    border: `1px solid ${colors.darkPurple}`,
    boxShadow: `0px 3px 10px ${colors.darkPurple}`,
    borderRadius: 16,
  };
  const customEdgeStyles = {
    stroke: colors.darkPurple,
    strokeWidth: 2,
  };

  const getEdgeStyle = (edge: Edge) => {
    if (
      edge.source === selectedNodeId ||
      edge.target === selectedNodeId ||
      edge.id === selectedEdgeId
    ) {
      return customEdgeStyles;
    }
    return {};
  };



  useEffect(() => {
    eventsend('workflow_pageview_web');
  }, []);
  const nodeTypes = useMemo(
    () => ({
      defaultResponse: DefaultResponseNode,
      incomingWA: IncomingWANode,
      shopify: ShopifyOrderNode,
      responseMessage: ResponseMessageNode,
      condition: ConditionNode,
      codeNode: CodeNode,
      timeDelay: TimeDelayNode,
      assignChatbot: AssignToChatBot,
      sendEmail: SendEmailNode,
      sendSMS: SendSMSNode,
      invokeNewFlow: InvokeNewFlow,
      sendWATemplate: SendWATemplate,
      catalog: SendWACatalog,
      whatsAppPayment: WAPaymentNode,
      endNode: EndFlowNode,
      facebookLead: FacebookLeadNode,
      assignAgent: AssignAgentNode,
      addToLabel: AddToLabel,
      metaPixelNode: PixelEventNode,
      updateBroadcast: UpdateBroadCastNode,
      campaign: CampaignSentNode,
      kylasUpdate: KylasUpdateNode,
      kylasCreate: KylasCreateNode,
      instagramLead: IncomingInstagramNode,
      instagramEvent: InstagramEventNode,
      instagramAction: InstagramResponseNode,
      updateAttribute: UpdateAttributeNode,
      attributeCondition: AttributeConditionNode,
      assignAIAssistant: AssignAIAssistantNode,
      updateChatStatus: UpdateChatStatusNode,
      pabblyEvent: PabblyEventNode,
      llama: LlamaNode,
      chatgpt: AssignGPTNode,
      webhookTrigger: WebhookTriggerNode,
      incomingWebhook: IncomingWebhookNode,
      wooWFNode: WooCommerceNode,
      contactWFNode: NewContactNode,
      updateShopifyAttributes: UpdateShopifyAttributesNode,
      formsWFNode: FormNode,
      feedbackNode: FeedbackCollectionNode,
    }),
    []
  );

  const onDragOver = useCallback((event: React.DragEvent) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);



  const temp = Array.isArray(nodes) ? [...nodes] : [];

  const index = temp?.map((e) => e.id).indexOf(editNodeData?.id || "");
  if (temp[index]) {
    const matchedNode = edges.filter((item) => item.target === temp[index].id);
    if (matchedNode[0]) {
      prevNode = temp.filter((item) => matchedNode[0].source === item.id)[0];
    }
  }


  return (
    <div
      className="container-fluid px-0"
      style={{ height: '50dvh', width: '100%', backgroundColor: colors.white02 }}
    >
      <div className="d-flex flex-column justify-content-between align-items-center w-100 h-100">

        <div
          className="d-flex flex-row justify-content-between align-items-center w-100"
          style={{ height: 'calc( 100vh - 82px )' }}
        >
          {/* Workflow Start */}
          <div className="" style={{ height: '100%', flex: 1, position: 'relative' }} ref={reactFlowWrapper}>

            <ReactFlow

              nodes={nodes?.map((node) => ({
                ...node,
                style: node.id === selectedNodeId ? customNodeStyles : {},
              }))}
              edges={edges?.map((edge) => ({
                ...edge,
                style: getEdgeStyle(edge),
              }))}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onDragOver={onDragOver}
              nodeTypes={nodeTypes}
            >
              <Controls />
              <MiniMap />
              <Background variant={BackgroundVariant.Dots} gap={12} size={1} />
            </ReactFlow>
          </div>
          {/* Workflow End */}
        </div>
      </div>
      <KeyPressOverviewModal show={showKeyPressModal} onHide={handleModalHide} />
    </div>
  );
};

export default WorkflowPreview;